<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'REVIEWER_COMMENTS' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>
<mat-dialog-content class="comments-content">
    <textarea readonly class="comments-textarea">{{ data.comments }}</textarea>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="openCloseBtn" mat-raised-button color="primary" [mat-dialog-close]>Ok</button>
</mat-dialog-actions>
